import api from "../api";

const qs = require("qs");

export default {
  state: {
    userApproval: [],
    error: null,
    company: {},
    user: [],
    user_approval_total: 0,
    set_user: {},
  },
  getters: {
    getUserApprovalData(state) {
      return state.userApproval;
    },
    getCompanyData(state) {
      return state.company;
    },
    getUserApprovalTotal(state) {
      return state.user_approval_total;
    },
    getSetUser(state) {
      return state.set_user;
    }
  },
  mutations: {
    CLEAR_USER_APPROVAL(state) {
      state.userApproval.splice(0)
    },
    ADD_USER_APPROVAL(state, data) {
      state.userApproval = data;
    },
    ADD_ERROR(state, data) {
      state.error = data;
    },
    ADD_COMPANY(state, data) {
      state.company = data;
    },
    UPDATE_USER_DATA(state, data) {
      state.user = data
    },
    SET_DEFAULT_PASSWORD(state, default_password) {
      if (state.user.hasOwnProperty('metadata')) {
        if (state.user.metadata.hasOwnProperty('default_password')) {
          state.user.metadata.default_password = default_password
        }
      }
    },
    CLEAR_USER_APPROVAL_TOTAL(state) {
      state.user_approval_total = 0;
    },
    SET_USER_APPROVAL_TOTAL(state, user_approval_total) {
      state.user_approval_total = user_approval_total;
    },
    CLEAR_COMPANY(state) {
      state.company = {}
    },
    SET_UPDATE(state, data) {
      state.set_user = data
    }
  },
  actions: {
    LOAD_USER_APPROVAL({ commit, rootState }, payload) {
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_all`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
            ...payload
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_USER_APPROVAL", response.data.data);
          }
        })
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    },
    LOAD_USER_APPROVAL_TOTAL({ commit, rootState }, payload) {
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_user_total`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
            ...payload
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("SET_USER_APPROVAL_TOTAL", response.data.data.total);
          }
        })
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    },
    LOAD_COMPANY({ commit, rootState }) {
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_company`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_COMPANY", response.data.data);
          }
        })
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    },
    UPDATE_USER({ commit, rootState }, payloads) {
      const { metadata } = payloads;
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/update_user`,
          qs.stringify({
            token: rootState.token,
            id: rootState.user.user.id,
            data: {
              metadata: metadata,
              clientid: rootState.clientid,
            },
          })
        )
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    },
    UPDATE_COMPANY({ commit, rootState }, payloads) {
      const { metadata } = payloads;
      let clientid = rootState.clientid;
      if (payloads.hasOwnProperty('administrator')) {
        if (payloads.hasOwnProperty('clientid')) {
          clientid = payloads.clientid
        }
      }
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/update_company`,
          qs.stringify({
            token: rootState.token,
            clientid,
            metadata
          })
        )
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    },
    UPDATE_USER_PASSWORD({ commit, rootState }, payloads) {
      const { password, old_password } = payloads;
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/update_user_password`,
          qs.stringify({
            token: rootState.token,
            id: rootState.user.user.id,
            password: password,
            old_password: old_password
          })
        )
        .then((response) => {
          commit("SET_UPDATE", response.data.data);
        })
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    }
  },
};
